import "core-js/stable";
import "regenerator-runtime/runtime";

import React, {useDebugValue, useState} from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import {createMemoryHistory} from "history"
import useStateWithLabel from "./helpers/cunstom_hooks/useStateWithLabel";
import initHBHE from "./Init";
import { i18n } from "./helpers/i18n/i18n";

// contexts
import {AppDataContextProvider} from 'contexts/app-data'
import BreakPointProvider from './contexts/breaking-point'
import { CountryContextProvider } from "./contexts/country-context";

//Components
import { ReactApplicationComponent } from './routes'
import StepsLoader from "./components/steps/steps-loader";

// Styles
import './styles/main.scss'

const elementId = "root";
const memoryHistory = createMemoryHistory();

const translations = JSON.parse(localStorage.getItem("translations"))

// Custom Hooks
React.useStateWithLabel = useStateWithLabel;


const lang = localStorage.getItem('language').toLocaleLowerCase()
// Initialize analytics
window.digitalData = {  
    dataLayerVersion: "V4.0",
    pageReady: "Y",
    pageReadyTime: Date.now() - window.performance.timing.navigationStart,
    Component: {
        attributes: {},
        category: {},
    },
    event: 
        [{
            eventInfo: {
                eventAction:"",
                eventName:"",
                eventType:"",
            }
        }],
    
    onlineSalesAndServiceFlows: {
        flowName: "",
        transactionID: "",
        flowType :"",
        stepName :"",
        stepSeq :"",
        stpFlag :"",
        product: [{
            productInfo: {
                productName: ""
            },
        }]
    },

    transaction: {
        transferType : {}
    },
    user: {}, 
    page: {
        attributes: {
            digitalChannel:"hb:easybanking web",
            language:lang,
            level4: "",
            pageLevel:'',
            authenticationStatus: 0,
            status: "",
            primaryCategory:"hb",
            subCategory1:"prof",
            subCategory2:"general",
        },
        pageInfo: {
            pageID: "",
            url: window.location.href
        },
    }
}


i18n.init({ translations });

// const cc = () => {
//     const c = document.cookie.includes("s_cc")
//     const ccBanner = document.getElementsByClassName('cookie_lang')
//     console.log(ccBanner)
//     if (c) ccBanner.hidden = true;
//     console.log(c)
// }
// cc()
// console.log = () => {};


// constants
const renderApp = () => ReactDOM.render(
    <Router history={memoryHistory}>
        <BreakPointProvider>
            <CountryContextProvider>
                <AppDataContextProvider>
                    {/* <StepsLoader loading={ true } masterLoader={ true }/> */}
                    <ReactApplicationComponent history={memoryHistory} location={window.location} />
                </AppDataContextProvider>
                </CountryContextProvider>
        </BreakPointProvider>
    </Router>, document.getElementById(elementId)
);
const renderLoader = () => ReactDOM.render(<StepsLoader loading={true} masterLoader={ true }/>, document.getElementById(elementId));

if (translations && Object.keys(translations.default[lang]).length > 0) {
    console.log("label in")
    renderApp() 
} else {
    console.log("label not in")
    renderLoader()
    setTimeout(() => {
        window.location.reload()
    }, 500)
}
